export const CLEAR_DOC_SUBTYPE_MANAGEMENT_STATE = 'CLEAR_DOC_SUBTYPE_MANAGEMENT_STATE';

export const GET_ALL_DOC_SUBTYPES = 'GET_ALL_DOC_SUBTYPES';
export const GET_ALL_DOC_SUBTYPES_SUCCESS = 'GET_ALL_DOC_SUBTYPES_SUCCESS';
export const GET_ALL_DOC_SUBTYPES_ERROR = 'GET_ALL_DOC_SUBTYPES_ERROR';

export const GET_DOC_SUBTYPE_BY_ID = 'GET_DOC_SUBTYPE_BY_ID';
export const GET_DOC_SUBTYPE_BY_ID_SUCCESS = 'GET_DOC_SUBTYPE_BY_ID_SUCCESS';
export const GET_DOC_SUBTYPE_BY_ID_ERROR = 'GET_DOC_SUBTYPE_BY_ID_ERROR';

export const CREATE_DOC_SUBTYPE = 'CREATE_DOC_SUBTYPE';
export const CREATE_DOC_SUBTYPE_SUCCESS = 'CREATE_DOC_SUBTYPE_SUCCESS';
export const CREATE_DOC_SUBTYPE_ERROR = 'CREATE_DOC_SUBTYPE_ERROR';

export const UPDATE_DOC_SUBTYPE = 'UPDATE_DOC_SUBTYPE';
export const UPDATE_DOC_SUBTYPE_SUCCESS = 'UPDATE_DOC_SUBTYPE_SUCCESS';
export const UPDATE_DOC_SUBTYPE_ERROR = 'UPDATE_DOC_SUBTYPE_ERROR';

export const DELETE_DOC_SUBTYPE = 'DELETE_DOC_SUBTYPE';
export const DELETE_DOC_SUBTYPE_SUCCESS = 'DELETE_DOC_SUBTYPE_SUCCESS';
export const DELETE_DOC_SUBTYPE_ERROR = 'DELETE_DOC_SUBTYPE_ERROR';
